import { lazyLoad } from '@react-page/editor';
import createPlugin from './createPlugin';
import FormStateHtmlRenderer from './Renderer/FormStateHtmlRenderer';
const FormStateControls = lazyLoad(() => import('./Controls/FormStateControls'));
export default (settings) => {
    const plugin = createPlugin(Object.assign({ Controls: FormStateControls, Renderer: FormStateHtmlRenderer }, settings));
    return plugin;
};
//# sourceMappingURL=index.js.map